import { getDataforUrl } from "./index";


export const getDashboardData = async (payload) => {
  return getDataforUrl("admin/getDashboardData").then((data) => {
    return data;
  });
};

